import '@mycashbacklanding/scss/app-front-page.scss';
import Utils from '@mycashbacklanding/js/services/utils';
import Slider from '@mycashbacklanding/js/services/slider';

document.addEventListener( "DOMContentLoaded", function () {

    // Utils
    Utils.click();
    Utils.bootstrap();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.scroll_reveal_init();
    Utils.lottie();

    // Slider
    Slider.hero();

    // Specific
    console.log('front-page');
})
